//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Onboarding.PortalPreview',
                {
                    url: '/PortalPreview',
                    component: 'portalPreviewComponent',
                });
        }
    ]);

    app.component('portalPreviewComponent', {
        templateUrl: 'App.Onboarding/States/PortalPreview/PortalPreview.template.html',
        controller: 'PortalPreviewController',
        bindings: {
            user: '<',
            userGroup: '<',
            onBehalfOfUserGroup: '<',
            onBehalfOfUser: '<',
        }
    });

    app.controller('PortalPreviewController', PortalPreviewController);

    PortalPreviewController.$inject = ['AuthService', '$cookies', 'permissionService'];

    function PortalPreviewController(AuthService, $cookies, permissionService) {
        var $ctrl = this;

        $ctrl.removeCookie = function () {
            $cookies.remove("is-onboarding");
        };
    }
})(window.angular, window.app);